<template>
  <span>
    <el-form-item
      label="总代名称"
      v-if="userType === 'admin' && showAgent"
      prop="agentid"
    >
      <el-select
        v-model="selectedAgent"
        placeholder="请输入代理商"
        clearable
        filterable
        @change="agentChanged"
      >
        <el-option
          v-for="item in agentListForPrompt"
          :key="item.agentid"
          :label="item.value"
          :value="item"
        >
        </el-option>
      </el-select>

      {{ selectedAgent.agentid }}
    </el-form-item>

    <el-form-item
      label="加盟商称"
      v-if="(userType === 'admin' || userType === 'agent') && showVendor"
      prop="vendorid"
    >
      <el-select
        v-model="selectedVendor"
        placeholder="请输入加盟商"
        clearable
        filterable
        @change="vendorChanged"
      >
        <el-option
          v-for="item in vendorListForPrompt"
          :key="item.vendorid"
          :label="item.value"
          :value="item"
        >
        </el-option>
      </el-select>
      {{ selectedVendor.vendorid }}
    </el-form-item>

    <el-form-item label="所属门店" prop="machineInShopid" v-if="showShop">
      <el-select
        v-model="selectedShop"
        placeholder="请输入门店"
        clearable
        filterable
        @change="shopChanged"
      >
        <el-option
          v-for="item in shopListForPrompt"
          :key="item.machineInShopid"
          :label="item.value"
          :value="item"
        >
        </el-option>
      </el-select>
      {{ selectedShop.shopid }}
    </el-form-item>
  </span>
</template>

<script>
//import { mapGetters } from "vuex";

export default {
  // props: ["initData", "showAgent", "showVendor", "showShop"],

  props: {
    initData: {
      type: Object,
      default: () => {
        return null;
      }
    },
    showAgent: {
      type: Boolean,
      default: true
    },
    showVendor: {
      type: Boolean,
      default: true
    },
    showShop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // showAgent: true,
      // showVendor: true,
      // showShop: true,

      selectedAgent: {},
      selectedVendor: {},
      selectedShop: {},
      agentListForPrompt: [],
      vendorListForPrompt: [],
      shopListForPrompt: [],
      userType: this.$getUserType()
    };
  },
  async mounted() {
    console.log("userType", this.userType);
    //await this.$AllMachineModelInfoList;
    if (!this.$AllAgentIDName || !this.$AllAgentIDName.length) {
      await this.$getAllAgentIDName();
    }
    if (!this.$AllVendorIDName || !this.$AllVendorIDName.length) {
      await this.$getAllVendorIDName();
    }
    if (!this.$AllShopIDName || !this.$AllShopIDName.length) {
      await this.$getAllShopIDName();
    }

    this.shopListForPrompt = this.$AllShopIDName;

    if (this.userType === "admin") {
      this.agentListForPrompt = this.$AllAgentIDName;
      if (!this.agentListForPrompt || !this.agentListForPrompt.length) {
        this.$message.error(
          "数据异常，请强刷新页面，或者关闭窗口重新登录后再试"
        );
      }
    }

    if (this.userType === "agent") {
      this.vendorListForPrompt = this.$AllVendorIDName;
      if (!this.vendorListForPrompt || !this.vendorListForPrompt.length) {
        this.$message.error(
          "数据异常，请强刷新页面，或者关闭窗口重新登录后再试"
        );
      }
    }

    // console.log("this.initData", this.initData);
    if (this.initData && Object.keys(this.initData).length) {
      this.fillValue(this.initData);
    }

    // console.log("this.agentListForPrompt", this.agentListForPrompt);
  },

  methods: {
    emitSelect() {
      this.$emit("select", {
        selectedAgent: this.selectedAgent,
        selectedVendor: this.selectedVendor,
        selectedShop: this.selectedShop
      });
    },
    emitInit() {
      this.$emit("init", {
        selectedAgent: this.selectedAgent,
        selectedVendor: this.selectedVendor,
        selectedShop: this.selectedShop
      });
    },

    agentChanged(x) {
      console.log("agentChanged", x);
      console.log("this.$AllVendorIDName", this.$AllVendorIDName);

      if (x == "") {
        this.selectedAgent = {};
      }

      this.selectedVendor = {};
      this.selectedShop = {};
      this.vendorListForPrompt = this.$AllVendorIDName.filter(
        m => m.agentid == x.agentid
      );
      // this.$queryVendorForPrompt(x.agentid, result => {
      //   this.vendorListForPrompt = result;
      // });
      this.emitSelect();
    },

    vendorChanged(x) {
      console.log(x);
      if (x == "") {
        this.selectedVendor = {};
      }
      this.selectedShop = {};
      this.shopListForPrompt = this.$AllShopIDName.filter(
        m => m.vendorid == x.vendorid
      );

      // this.$queryShopForPrompt(x.vendorid, result => {
      //   this.shopListForPrompt = result;
      //   console.log(this.shopListForPrompt);
      // });
      this.emitSelect();
    },

    shopChanged(x) {
      console.log(x);
      if (x == "") {
        this.selectedShop = {};
      }
      this.emitSelect();
    },

    async fillValue(v) {
      console.log("fillValue trigged", v, v.selectedAgentid);
      this.selectedAgent = this.agentListForPrompt.find(
        x => x.agentid === v.selectedAgentid
      );
      console.log("this.vendorListForPrompt", this.vendorListForPrompt);
      console.log("this.selectedAgent", this.selectedAgent);
      if (this.selectedAgent && Object.keys(this.selectedAgent).length) {
        await this.$queryVendorForPrompt(this.selectedAgent.agentid, result => {
          this.vendorListForPrompt = result;
        });
        this.selectedVendor = this.vendorListForPrompt.find(
          x => x.vendorid === v.selectedVendorid
        );
      }
      if (this.selectedVendor && Object.keys(this.selectedVendor).length) {
        await this.$queryShopForPrompt(this.selectedVendor.vendorid, result => {
          this.shopListForPrompt = result;
        });

        this.selectedShop = this.shopListForPrompt.find(
          x => x.shopid === v.selectedShopid
        );
      }
      console.log(this.selectedAgent, this.selectedVendor, this.selectedShop);

      this.emitInit();

      // this.selectedVendor = v.selectedVendor;
      // this.selectedShop = v.selectedShop;
    }
  }
};
</script>

<style lang="less" scoped></style>
